/**
 * @generated SignedSource<<144df4af7d3a85b72e56c3e3fc911cc3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddSplitRequestInput = {
  clearanceItemId?: string | null | undefined;
  productId: string;
  specialItemId?: string | null | undefined;
};
export type AddSplitRequestMutation$variables = {
  input: AddSplitRequestInput;
};
export type AddSplitRequestMutation$data = {
  readonly addSplitRequest: {
    readonly splitRequestEdge: {
      readonly __typename: "SplitRequestEdge";
      readonly node: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type AddSplitRequestMutation = {
  response: AddSplitRequestMutation$data;
  variables: AddSplitRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddSplitRequestPayload",
    "kind": "LinkedField",
    "name": "addSplitRequest",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SplitRequestEdge",
        "kind": "LinkedField",
        "name": "splitRequestEdge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SplitRequest",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddSplitRequestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddSplitRequestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2b3eec1d767ffa85fdbae95c71742973",
    "id": null,
    "metadata": {},
    "name": "AddSplitRequestMutation",
    "operationKind": "mutation",
    "text": "mutation AddSplitRequestMutation(\n  $input: AddSplitRequestInput!\n) {\n  addSplitRequest(input: $input) {\n    splitRequestEdge {\n      __typename\n      node {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c837c72ac4adfb783c1150a2ed02ae1";

export default node;
